<template>
  <div class="workflow-edit">
    <div class="modal workflow-edit-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card">
        <section class="modal-card-body">
          <div v-show="!addingStops">
            <!-- <i class="fa fa-external-link-alt has-text-link" @click="openJSONEditor" /> -->
            <p class="is-size-4 has-text-info">Edit Workflow</p>
            <div class="no-scrollbar" style="max-height:60vh; overflow:scroll;">
              <div class="field has-text-left">
                <input
                  class="is-checkradio"
                  id="anyLocationCheckbox"
                  type="checkbox"
                  name="anyLocationCheckbox"
                  v-model="allowAnyLocation"
                />
                <label for="anyLocationCheckbox">Any Location</label>
              </div>
              <div class="field has-text-left">
                <!-- checked="isDropoffOnly" -->
                <input
                  class="is-checkradio"
                  id="dropoffOnlyCheckbox"
                  type="checkbox"
                  name="dropoffOnlyCheckbox"
                  v-model="isDropoffOnly"
                />
                <label for="dropoffOnlyCheckbox">Dropoff Only</label>
              </div>
              <div class="field has-text-left">
                <input
                  class="is-checkradio"
                  id="roomNumberCheckbox"
                  type="checkbox"
                  name="roomNumberCheckbox"
                  v-model="requiresUnitNumber"
                />
                <label for="roomNumberCheckbox">Require Unit Number</label>
              </div>
              <div class="field has-text-left">
                <input
                  class="is-checkradio"
                  id="authCheckbox"
                  type="checkbox"
                  name="authCheckbox"
                  v-model="requiresAuth"
                />
                <label for="authCheckbox">Require Authentication</label>
              </div>
              <div class="field" v-if="requiresAuth">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="passcode"
                    type="number"
                    placeholder="Passcode"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                </p>
              </div>

              <div class="field">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="w.name"
                    type="text"
                    placeholder="Workflow Name"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-signature"></i>
                  </span>
                </p>
              </div>

              <div class="field">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="phoneNumber"
                    type="text"
                    placeholder="Phone Number"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-phone"></i>
                  </span>
                </p>
              </div>

              <div class="field">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="workflowInfo"
                    type="text"
                    placeholder="Information"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-info"></i>
                  </span>
                </p>
              </div>

              <div class="field">
                <p class="control has-icons-left">
                  <input
                    class="input is-medium"
                    v-model="operatingHours"
                    type="text"
                    placeholder="Hours of operation"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-clock"></i>
                  </span>
                </p>
              </div>

              <div class="field has-addons" v-for="stop in stops" :key="stop.number">
                <div class="control has-icons-left is-expanded">
                  <input
                    class="input is-fullwidth has-text-info"
                    :class="{ 'is-danger': !stop.name }"
                    type="text"
                    v-model="stop.name"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-map-pin"></i>
                  </span>
                </div>
                <div class="control">
                  <a class="button" @click="deleteStop(stop.number)">
                    <i class="fa fa-minus-circle has-text-danger" />
                  </a>
                </div>
              </div>
              <!-- <br /> -->
              <!-- </div> -->

              <div class="field">
                <p class="control">
                  <button
                    class="button is-warning is-fullwidth is-medium is-rounded"
                    @click="addStops"
                  >Add Stop</button>
                </p>
              </div>
              <div style="height:3px"></div>
            </div>

            <div class="field" v-show="stops.length >= minStops">
              <p class="control">
                <button
                  class="button is-success is-fullwidth is-medium is-rounded"
                  @click="submit"
                >Update</button>
              </p>
            </div>
          </div>
          <!-- </div> -->

          <div v-show="addingStops">
            <div class="field has-addons" style="margin-bottom:10px">
              <p class="control has-icons-left is-expanded">
                <input
                  class="input is-medium is-rounded"
                  ref="autocomplete"
                  placeholder="Stop"
                  onfocus="value = ''"
                  type="text"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-map-pin" />
                </span>
              </p>
              <div class="control">
                <a class="button is-danger is-medium is-rounded" @click="cancelStopLocation">
                  <i class="fa fa-times-circle" />
                </a>
              </div>
            </div>

            <WorkflowEditStop @editedStop="setStopLocation" />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import WorkflowEditStop from "@/components/WorkflowEditStop.vue";
import $Scriptjs from "scriptjs";

export default {
  name: "WorkflowEdit",
  components: { WorkflowEditStop },
  data() {
    return {
      w: {
        name: ""
      },
      autocomplete: undefined,
      place: undefined, // google place result
      placeCoords: null,
      workflowType: "Private Tuk Tuk",
      workflowName: "Tuk Tuk",
      workflowInfo: "",
      phoneNumber: "+66",
      operatingHours: "",
      stops: [], // stop {number, name, coords}
      addingStops: false,
      minStops: 2,
      allowAnyLocation: false,
      isDropoffOnly: false,
      requiresAuth: false,
      requiresUnitNumber: false,
      passcode: ""
    };
  },
  computed: {
    // isAuthRequired() {
    //   if (!this.w) return false;
    //   console.log("isAuthRequired", this.w.data.requires_authentication);
    //   return this.w.data.requires_authentication;
    // }
  },
  mounted() {
    var googlePlacesURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(googlePlacesURL, () => this.setupGooglePlaces());

    EventBus.$on("EDIT_WORKFLOW", payload => {
      this.w = payload;
      this.stops = this.w.data.stops;
      this.allowAnyLocation = this.w.data.any_location;
      this.isDropoffOnly = this.w.data.dropoff_only;
      this.requiresAuth = this.w.data.requires_authentication;
      this.passcode = this.w.data.passcode;
      this.requiresUnitNumber = this.w.data.requires_unit_number;
      this.console("edit workflow", payload);
      console.log(`requiresAuth ${this.requiresAuth}`);
    });
  },
  methods: {
    setupGooglePlaces() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [] // uses all, options are ["address", "establishment", "geocode"]
          // componentRestrictions: { country: "th" }
        }
      );
      this.geolocate();

      this.autocomplete.addListener("place_changed", () => {
        var place = this.autocomplete.getPlace();
        var coords = [
          place.geometry.location.lat(),
          place.geometry.location.lng()
        ];
        this.$store.commit("setGooglePlace", { place: place, coords: coords });
        this.console("place", place);
      });
    },
    closeModal() {
      // reset data
      this.workflowName = "Tuk Tuk";
      this.phoneNumber = "+66";
      this.stops = [];
      this.addingStops = false;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    // toggleDropoff(e) {
    //   this.console("toggleDropoff", e.target.checked);
    //   if (e.target.checked) this.isDropoffOnly = true;
    //   else this.isDropoffOnly = false;
    // },
    onWorkflowType() {
      // special case Sii Lor
      if (this.workflowType === "Sii Lor") {
        this.workflowName = this.workflowType;
        this.minStops = 1;
      }
      // special case Admin
      if (this.workflowType === "Admin") {
        var businessID = this.$store.state.selectedBusiness.id;
        this.$store
          .dispatch("createWorkflow", {
            business_id: businessID,
            name: this.workflowType,
            workflow_type_name: this.workflowType,
            created_by: this.$store.state.user.id,
            data: { phone_number: "+66909588716" } // I think data.admin_phone_number would be useful...
          })
          .then(() => {
            this.$store
              .dispatch("getWorkflows", businessID)
              .then(() => {
                this.closeModal();
                this.success(); // successModal mixin
              })
              .catch(err => this.apiError(err));
          })
          .catch(err => this.apiError(err));
      }
    },
    addStops() {
      if (this.stops.some(el => el.name === "")) {
        this.$swal("Set stop name");
        return;
      }
      this.addingStops = true;
      // document.getElementById("google-autocomplete").value = "";
      this.$refs.autocomplete.value = "";
      EventBus.$emit("EDITING_STOPS", this.stops); // trigger to redraw map in WorkflowCreateStop
    },
    cancelStopLocation() {
      this.addingStops = false;
    },
    setStopLocation(val) {
      console.log("setStopLocation", val);
      // if (document.getElementById("google-autocomplete").value === "") {
      if (this.$refs.autocomplete.value === "") {
        this.$store.commit("notGooglePlace");
      }
      this.addingStops = false;
      var newStop = {
        id: this.newUUID(),
        number: this.stops.length + 1,
        name: this.$store.getters.stopName,
        lat: val.lat, //this.$store.state.stopCoords.lat,
        lon: val.lon //this.$store.state.stopCoords.lng
      };
      this.stops.push(newStop);
      this.console("stops", this.stops);
    },
    deleteStop(stopNumber) {
      this.console("deleteStop", stopNumber);
      this.stops.splice(stopNumber - 1, 1);
      this.stops.forEach((stop, index) => (stop.number = index + 1)); // reset stop numbers
    },
    // Bias autocomplete to the user's location,
    geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          });
          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },
    submit() {
      if (this.workflowType === "") {
        this.$swal("Set workflow type");
        return;
      }
      if (this.stops.some(el => el.name === "")) {
        this.$swal("Set stop name");
        return;
      }
      if (this.requiresAuth && (!this.passcode || this.passcode.length !== 4)) {
        this.$swal("Set a 4 digit passcode or turn off authentication");
        return;
      }
      var businessID = this.$store.state.selectedBusiness.id;
      var loader = this.loadingDots("lightgreen");
      console.log("updateWorkflow", this.w);
      this.$store
        .dispatch("updateWorkflow", {
          id: this.w.id,
          name: this.w.name,
          data: {
            any_location: this.allowAnyLocation,
            dropoff_only: this.isDropoffOnly,
            requires_unit_number: this.requiresUnitNumber,
            requires_authentication: this.requiresAuth,
            passcode: this.passcode,
            phone_number: this.phoneNumber,
            info: this.workflowInfo,
            operating_hours: this.operatingHours,
            stops: this.stops
          }
        })
        .then(() => {
          this.$store
            .dispatch("getWorkflows", businessID)
            .then(() => {
              this.closeModal();
              this.success(); // successModal mixin
            })
            .catch(err => this.apiError(err));
        })
        .catch(err => this.apiError(err))
        .finally(() => loader.hide());
    }
  }
};
</script>

<style scoped>
.modal-card-body {
  max-width: 640px;
  position: relative;
  padding: 10px;
  border-radius: 25px;
}
/* .fa-external-link-alt {
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px;
} */
</style>